/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { addClasses } from 'lib/helpers/class.js';
import { DocumentList, DocumentMiniPreview } from '#@itinerary/documents/document-list.jsx';
import File, { DocumentPreview } from '#lib/components/file-dnd.jsx';
import { DocumentModal } from '#components/document-modal.jsx';
import { SectionHeading } from '#components/headings.jsx';

export function Documents(props) {
    const {
        form,
        documents,
        setActiveDocument,
        isDocumentActive,
        onEditDocument,
        onDeleteDocument,
        onAddDocument,
        getActiveDocument,
        showDocumentModal,
        setShowDocumentModal
    } = props;

    const activeFiles = [getActiveDocument()];

    return (
        <form className="contents" {...form.props.form}>
            <section className="flex flex-col w-full gap-y-2">
                <SectionHeading id="docs" subtext={_t.edit.documentsAndVouchersDescription()}>
                    {_t.edit.documentsAndVouchers()}
                </SectionHeading>
                <div className="grid grid-cols-1 xl:grid-cols-2 gap-2">
                    <div className="col-span-1 ">
                        <DocumentList>
                            {documents?.map((el, i) => (
                                <DocumentList.Item key={`${i}_${el.id}`}>
                                    <DocumentMiniPreview
                                        active={isDocumentActive(el.id)}
                                        name={el.name}
                                        visible={el.visible}
                                        isLoading={el.isLoading}
                                        onClick={() => setActiveDocument(el.id)}
                                        onEdit={(field, value) => {
                                            onEditDocument(el.id, field, value);
                                        }}
                                        onDelete={() => onDeleteDocument(el.id)}
                                    />
                                </DocumentList.Item>
                            ))}
                        </DocumentList>
                        <DocumentList.AddItem
                            onAdd={onAddDocument}
                            multiple={true}
                            accept="application/pdf,image/*,text/*,.txt"
                        />
                    </div>
                    <div className="col-span-1 h-full">
                        <File
                            name="documents"
                            existingFiles={activeFiles}
                            className={addClasses('h-full min-h-[147px]')}
                            onChange={onAddDocument}
                            onClear={setActiveDocument}
                            multiple={true}
                            accept="application/pdf,image/*,text/*,.txt"
                        >
                            {({ clear }) => {
                                const activeDocument = getActiveDocument();
                                return (
                                    <>
                                        {activeDocument && (
                                            <DocumentPreview
                                                document={activeDocument}
                                                clear={clear}
                                                handleModal={() => {
                                                    setShowDocumentModal(true);
                                                }}
                                            />
                                        )}
                                        <DocumentModal
                                            document={activeDocument}
                                            isOpen={showDocumentModal}
                                            onClose={() => setShowDocumentModal(false)}
                                        />
                                    </>
                                );
                            }}
                        </File>
                    </div>
                </div>
            </section>
        </form>
    );
}
